// extracted by mini-css-extract-plugin
export default {"App":"Home_App__KXZCM","Header":"Home_Header__of56y","ProxySizing":"Home_ProxySizing__vXzs2","Loader":"Home_Loader__x2qsz","Proxy":"Home_Proxy__1rktj","Log":"Home_Log__XH5Jl"};